const dispatchRoiCalculatorUngateEvent = require("./dispatchRoiCalculatorUngateEvent");


/**
 * @param data {UngatePayload}
 * @return {void}
 */
module.exports = function ungateRoiCalculatorForm(data) {
    document.querySelectorAll('[data-component="roi-calculator-iframe"]').forEach(roiCalculatorIframe => {
        if (roiCalculatorIframe instanceof HTMLIFrameElement) {
            dispatchRoiCalculatorUngateEvent(roiCalculatorIframe, data);
        }
    });
}
